import brand from '@/core/brand'
import tradicional from './tradicional'
import bravo from './bravo'

const content = { tradicional, bravo }

export default content[brand.key] || tradicional
